<template>
  <SfSidebar
    :class="position"
    class="sidebar"
    @close="closeSidebar"
    v-bind="sidebarProps"
    :visible="visible"
  >
    <div class="sidebar-content">
      <CartSidebarContent v-if="sidebar.type === 'cart'" />
      <WishlistSidebarContent v-if="sidebar.type === 'wishlist'" />
      <SearchSidebarContent v-if="sidebar.type === 'search'" />
      <MenuSidebarContent v-if="sidebar.type === 'menu'" />
      <UserSidebarContent v-if="sidebar.type === 'user'" />
    </div>
  </SfSidebar>
</template>
<script>
import _ from 'lodash';
import { SfSidebar } from '@storefront-ui/vue';
import { UserSidebarContent } from '@/modules/user';
import { SearchSidebarContent } from '@/modules/level4';
import CartSidebarContent from '@/modules/checkout/components/sidebars/CartSidebarContent.vue';
import WishlistSidebarContent from '@/modules/checkout/components/sidebars/WishlistSidebarContent.vue';
import sidebar from '../../mixins/sidebar';
import MenuSidebarContent from '../sidebars/MenuSidebarContent.vue';

export default {
  name: 'Sidebar',
  mixins: [sidebar],
  components: {
    SfSidebar,
    CartSidebarContent,
    WishlistSidebarContent,
    MenuSidebarContent,
    UserSidebarContent,
    SearchSidebarContent,
  },
  updated() {
    this.visible = this.sidebar.visible;
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    sidebarProps() {
      return _.omit(this.sidebar, ['visible']);
    },
    position() {
      return `sf-sidebar--${this.sidebar.position}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
.sidebar /deep/ .sf-sidebar__content {
  padding: 0;
}

.sidebar-content {
  overflow: auto;
  padding: var(--sidebar-content-padding, var(--spacer-base) var(--spacer-sm));
}
</style>
